import { StyleSheet, Text, View, type StyleProp, type TextStyle } from 'react-native';
import { useTranslation } from 'react-i18next';

import { useTheme } from '@/contexts/ThemeContext';
import { useBugReport } from '@/contexts/BugReportContext';
import { fontSize, spacing } from '@/constants/theme';

type Props = {
  children: string | null | undefined;
  style?: StyleProp<TextStyle>;
};

/** Μήνυμα σφάλματος οθόνης — κάτω από αυτό εμφανίζεται πάντα ένα μικρό,
 * πατήσιμο "Πατήστε εδώ για bug report" που ανοίγει απευθείας το modal
 * υποβολής bug/βελτίωσης, με το ίδιο το μήνυμα σφάλματος προσυμπληρωμένο —
 * ώστε ο χρήστης να μπορεί να το αναφέρει άμεσα χωρίς να βγει από την οθόνη. */
export function ErrorText({ children, style }: Props) {
  const { colors } = useTheme();
  const { t } = useTranslation();
  const { open } = useBugReport();

  if (!children) return null;

  return (
    <View style={styles.wrap}>
      <Text style={[styles.error, { color: colors.danger }, style]}>{children}</Text>
      <Text
        style={[styles.reportLink, { color: colors.primary }]}
        onPress={() => open(children)}
        accessibilityRole="button"
      >
        {t('common.tapToReportBug')}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: { gap: 2 },
  error: { fontSize: fontSize.sm, fontWeight: '600' },
  reportLink: { fontSize: 12, fontWeight: '700', marginTop: 1, marginBottom: spacing.xs },
});
